import React, { useState } from 'react';
import { StarRating } from './StarRating';

export const RatingSection = () => {
  const [averageRating, setAverageRating] = useState(4.5);
  const [ratingCount, setRatingCount] = useState(1250);

  const handleRate = (newRating: number) => {
    // In a real app, this would make an API call
    const newCount = ratingCount + 1;
    const newAverage = ((averageRating * ratingCount) + newRating) / newCount;
    setAverageRating(Number(newAverage.toFixed(1)));
    setRatingCount(newCount);
  };

  return (
    <div className="flex flex-col items-center py-8 bg-white/5 backdrop-blur-sm rounded-lg">
      <StarRating onRate={handleRate} />
      <div className="mt-2 text-center">
        <p className="text-sm text-gray-400">
          Average rating: {averageRating} out of 5
          <br />
          Based on {ratingCount} ratings
        </p>
      </div>
    </div>
  );
};